export class Model_CRM_LEAD_Note{

    public  LeadId : number;
    public  LeadNote : string;

  

}